import {Component, EventEmitter, Input, Output} from '@angular/core';
import {isDefined, isNullOrUndefined} from 'src/app/commons/utils';
import {BiometricType} from '../../../../domain/biometric-type';
import {IonicModule} from '@ionic/angular';

@Component({
  selector: 'app-keyboard',
  imports: [IonicModule],
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.scss']
})
export class KeyboardComponent {
  public readonly isNullOrUndefined = isNullOrUndefined;
  public readonly BiometricType = BiometricType;

  @Input() biometricType: BiometricType;
  @Output() readonly keyEmitter = new EventEmitter<string>();
  @Output() readonly login = new EventEmitter<any>();

  handleInput(pinDigit: string): void {
    this.keyEmitter.emit(pinDigit);
  }

  loginWithBiometrics(): void {
    if (isDefined(this.biometricType)) {
      this.login.emit();
    }
  }
}
